import { CONSUMPTION_TAX_RATE } from 'constant';

export const priceToWithoutTax = (priceWithTax: number) => {
  return Math.ceil(priceWithTax / (1 + CONSUMPTION_TAX_RATE));
};

export const priceToWithTax = (priceWithoutTax: number) => {
  return Math.ceil(priceWithoutTax * (1 + CONSUMPTION_TAX_RATE));
};
